import { memo } from 'react';

import defaultTimeZone from '@/constants/defaultTimeZone';
import MedicalStarterSequenceForm from '@/forms/MedicalStarterSequenceForm';
import { Alert, BetaBadge } from '@/ui';
import Modal from '@/ui/components/Modal';

import type { Props } from './types';

const MedicalStarterSequenceModal = ({ onClose, onSuccess, open, person }: Props) => {
  const { episode_of_care, time_zone } = person;
  const currentActivePhase = episode_of_care?.current_active_phase;

  const handleSuccess = () => {
    onClose();
    onSuccess?.();
  };

  const renderBody = () => {
    if (!episode_of_care) {
      return <Alert variant="info" message="This person has no episode of care" />;
    }

    if (!currentActivePhase) {
      return <Alert variant="info" message="This person has no active phase" />;
    }

    return (
      <MedicalStarterSequenceForm
        onSuccess={handleSuccess}
        phaseId={currentActivePhase.id}
        timeZone={time_zone || defaultTimeZone}
      />
    );
  };

  return (
    <Modal
      dataTestId="medical-starter-sequence-modal"
      open={open}
      onClose={onClose}
      overflowVisible
      title={
        <>
          Create Medical Starter Sequence <BetaBadge variant="superscript" />
        </>
      }>
      <div>{renderBody()}</div>
    </Modal>
  );
};

export default memo(MedicalStarterSequenceModal);
